import { useMemo } from 'react';
import { useDsTranslate } from '../context/DsProvider';
import styles from './FieldToolbar.module.scss';

interface FieldToolbarProps {
  onAddField: (fieldType: string) => void;
  horizontal?: boolean;
}

export function FieldToolbar({ onAddField, horizontal = false }: FieldToolbarProps) {
  const t = useDsTranslate();

  const FIELD_TYPES = useMemo(() => [
    { type: 'SIGNATURE', label: t('K_DS_FIELD_SIGNATURE', 'Signature'), icon: '✍' },
    { type: 'INITIALS', label: t('K_DS_FIELD_INITIALS', 'Initials'), icon: 'AB' },
    { type: 'NAME', label: t('K_DS_FIELD_NAME', 'Full Name'), icon: '👤' },
    { type: 'EMAIL', label: t('K_DS_FIELD_EMAIL', 'Email'), icon: '@' },
    { type: 'PHONE', label: t('K_DS_FIELD_PHONE', 'Phone Number'), icon: '📞' },
    { type: 'TITLE', label: t('K_DS_FIELD_TITLE', 'Title'), icon: '📋' },
    { type: 'COMPANY', label: t('K_DS_FIELD_COMPANY', 'Company'), icon: '🏢' },
    { type: 'TEXT', label: t('K_DS_FIELD_TEXT', 'Text Field'), icon: 'T' },
    { type: 'NUMBER', label: t('K_DS_FIELD_NUMBER', 'Number'), icon: '#' },
    { type: 'CURRENCY', label: t('K_DS_FIELD_CURRENCY', 'Currency'), icon: '$' },
    { type: 'DATE', label: t('K_DS_FIELD_DATE', 'Date'), icon: '📆' },
    { type: 'DATE_SIGNED', label: t('K_DS_FIELD_DATE_SIGNED', 'Date Signed'), icon: '📅' },
    { type: 'DROPDOWN', label: t('K_DS_FIELD_DROPDOWN', 'Dropdown'), icon: '▾' },
    { type: 'CHECKBOX', label: t('K_DS_FIELD_CHECKBOX', 'Checkbox'), icon: '☑' },
  ], [t]);

  return (
    <div className={horizontal ? styles.toolbarHorizontal : styles.toolbar}>
      {!horizontal && (
        <div className={styles.sectionTitle}>
          {t('K_DS_DRAG_OR_CLICK', 'Drag or click to add')}
        </div>
      )}
      <div className={horizontal ? styles.fieldListHorizontal : styles.fieldList}>
        {FIELD_TYPES.map((field) => (
          <button
            key={field.type}
            className={horizontal ? styles.fieldChip : styles.fieldItem}
            onClick={() => onAddField(field.type)}
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData('application/field-type', field.type);
              e.dataTransfer.effectAllowed = 'copy';
            }}
            title={field.label}
          >
            <span className={styles.fieldIcon}>{field.icon}</span>
            {!horizontal && <span className={styles.fieldLabel}>{field.label}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
